import { ContextState, FolderContextMenuBase, MenuDataNode } from 'src/content/configuration/FolderContextMenuBase';
import { API_URL } from 'src/data/Api';

export type { ContextState, MenuDataNode };

export class GroupNavFolderContextMenu extends FolderContextMenuBase {
  constructor(
    getState: () => ContextState,
    setState: (state: ContextState) => void,
    onDelete?: (item: MenuDataNode) => void,
    createBody: Record<string, any> = {},
    reload: () => void = () => { return void 0; }
  ) {
    super({
      getState,
      setState,
      onDelete,
      isNavMenu: true,
      createUrl: API_URL.GROUPS_FOLDER,
      getIdFromResponse: d => d.group_folder_id,
      getItemDataUrl: id => `${API_URL.GROUPS_FOLDER}/${id}`,
      getItemMenuUrl: (id, hwType) => `/api/menu/v1/folder/hw_type/${hwType}/group?ids=${id}`,
      renameUrl: id => `${API_URL.GROUPS_FOLDER}/${id}`,
      deleteUrl: id => `${API_URL.GROUPS_FOLDER}/${id}`,
      reload,
      createBody,
    });
  }
}
